<template>
  <header class="header-nav">
    <div class="navbar-container">
      <!-- 左侧LOGO+品牌名 -->
      <div class="navbar-logo" @click="$router.push('/')">
        <img src="@/assets/images/logo.png" alt="logo" class="logo-img" />
        <span class="brand-name">{{ $t('nav.brand') }}</span>
      </div>
      
      <!-- 桌面端导航菜单 -->
      <div class="desktop-nav">
        <nav class="navbar-menu">
          <ul>
            <li v-for="item in navList" :key="item.path">
              <router-link :to="item.path" active-class="active-link" exact>{{ item.label }}</router-link>
            </li>
          </ul>
        </nav>
        <!-- 右侧Contact+语言切换 -->
        <div class="navbar-actions">
          <el-button class="contact-btn" type="default" size="medium">{{ $t('nav.contact') }}</el-button>
          <span class="lang-btn" @click="toggleLanguage">
            <span class="flag-circle-outer">
              <img 
                :src="currentLanguage === 'zh' ? require('@/assets/images/english.png') : require('@/assets/images/chinese.png')" 
                :alt="currentLanguage === 'zh' ? 'English' : '中文'"
                class="flag-img"
              />
            </span>
          </span>
        </div>
      </div>
      
      <!-- 移动端导航 -->
      <MobileNav />
    </div>
  </header>
</template>

<script>
import MobileNav from './MobileNav.vue'

export default {
  name: 'HeaderNav',
  components: {
    MobileNav
  },
  computed: {
    currentLanguage() {
      return this.$i18n.locale
    },
    navList() {
      // 菜单配置，label为多语言key，path为路由路径
      return [
        { label: this.$t('nav.home'), path: '/' },
        { label: this.$t('nav.services'), path: '/services' },
        { label: this.$t('nav.story'), path: '/about' },
        { label: this.$t('nav.testimonials'), path: '/testimonials' },
        { label: this.$t('nav.parents'), path: '/parents' },
        { label: this.$t('nav.blog'), path: '/blog' }
      ]
    }
  },
  methods: {
    toggleLanguage() {
      const newLang = this.currentLanguage === 'zh' ? 'en' : 'zh'
      this.$i18n.locale = newLang
      localStorage.setItem('language', newLang)
    }
  }
}
</script>

<!-- i18n key 建议：
nav: {
  brand: 'Cambridge HOPE Guardianship' / '剑桥科博留学',
  home: 'Home' / '首页',
  guardianship: 'Guardianship' / '服务',
  story: 'Our Story' / '品牌故事',
  successes: 'Successes' / '客户感言',
  resources: 'Resources' / '家长专区',
  blog: 'Blog' / '博客',
  contact: 'Contact' / '联系我们'
}
-->

<style lang="scss" scoped>
.header-nav {
  width: 100%;
  background: #fff;
  position: relative;
  z-index: 1000; /* 确保导航栏在最上层 */
}

.navbar-container {
  width: 100%;
  height: 92px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 80px;
  
  @media (max-width: $breakpoint-sm) {
    padding: 0 20px;
    height: 70px;
  }
}

.navbar-logo {
  display: flex;
  align-items: center;
  cursor: pointer;

  .logo-img {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    margin-right: 6px;
    object-fit: contain;
    background: #fff;
    
    @media (max-width: $breakpoint-sm) {
      width: 36px;
      height: 36px;
      margin-right: 10px;
    }
  }

  .brand-name {
    font-size: 24px;
    font-weight: 700;
    color: #282938;
    letter-spacing: 0.5px;
    
    @media (max-width: $breakpoint-sm) {
      font-size: 18px;
    }
  }
}

.desktop-nav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  
 
}

.navbar-menu {
  flex: 1;
  display: flex;
  justify-content: center;
  margin-right: 30px;
  
  ul {
    display: flex;
    flex-direction: row;
    gap: 16px;
    list-style: none;
    margin: 0;
    padding: 0;
    width: fit-content;
    max-width: 625px;
    height: 40px;
    align-items: center;

    li {
      display: flex;
      align-items: center;
      height: 40px;

      a {
        color: #282938;
        font-size: 16px;
        font-weight: 500;
        text-decoration: none;
        padding: 8px 0;
        position: relative;
        transition: color 0.2s;

        &.active-link {
          color: #282938;
          font-weight: 500;
        }

        &:hover {
          color: #1e90ff;
        }
      }
    }
  }
}

.navbar-actions {
  display: flex;
  align-items: center;
  gap: 18px;

  .contact-btn {
    border: 1.5px solid #282938;
    border-radius: 22px;
    background: #fff;
    color: #282938;
    font-weight: 500;
    padding: 0 22px;
    height: 38px;
    transition: all 0.2s;

    &:hover {
      background: #282938;
      color: #fff;
    }
  }

  .lang-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 22px;

    .flag-circle-outer {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
      position: relative;
    }

    .flag-img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      border-radius: 50%;
    }
  }
}
</style> 